import { useConversationKeywords } from '@hooks/settings/conversation-keywords/useConversationKeywords';
import { useConversationKeywordsActions } from '@hooks/settings/conversation-keywords/useConversationKeywordsActions';
import type React from 'react';
import { KeywordDataModal } from './KeywordDataModal';

export const EditKeywordModal: React.FC = () => {
  const { updateConversationKeyword } = useConversationKeywordsActions();
  const { selectedKeyword, keywords } = useConversationKeywords();

  const handleSubmit = async (keyword: string) => {
    if (selectedKeyword?._id?.toString()) {
      await updateConversationKeyword(selectedKeyword._id?.toString(), keyword);
    }
  };

  // Exclude the current keyword text from the duplicate check so that the user
  // can re-save without changing the value (and so only other keywords block it)
  const existingKeywordsExcludingCurrent = keywords
    .map((keyword) => keyword.keyword)
    .filter((keyword) => keyword !== selectedKeyword?.keyword);

  return (
    <KeywordDataModal
      onSubmit={handleSubmit}
      defaultValue={selectedKeyword?.keyword}
      existingKeywords={existingKeywordsExcludingCurrent}
    />
  );
};

export default EditKeywordModal;
